import { Site } from '@crimsontide/core/client/interfaces'
import DotNetObject = DotNet.DotNetObject;

let dotNetObj: DotNetObject;

export const SiteService = (() => {
  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getSites = async (customerIds: string[], siteId?: string): Promise<Site[]> => {
    return await fetch('/api/Site/getCascading',
      {
        method: 'POST',
        body: JSON.stringify({
          customerIds: customerIds,
          siteId: siteId,
        }),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF': '1',
        }
      }
    ).then(sites => sites.json());
  };

  return {
    setDotNetReference,
    getSites,
  };
})();
